import { Token } from '../text-diff/diff';

export const sliceTokensByChars = (tokens: Token[], limit: number): Token[] => {
  if (limit === 0) {
    return [];
  }

  if (limit > 0) {
    let currentLength = 0;

    for (let i = 0; i < tokens.length; i++) {
      const token = tokens[i];
      const tokenLength = typeof token === 'string' ? token.length : token[0].length;

      if (currentLength + tokenLength > limit) {
        const remainingChars = limit - currentLength;

        if (remainingChars <= 0) {
          return tokens.slice(0, i);
        }

        if (typeof token === 'string') {
          return [...tokens.slice(0, i), token.slice(0, remainingChars)];
        }

        return [...tokens.slice(0, i), [token[0].slice(0, remainingChars), token[1]]];
      }

      currentLength += tokenLength;
    }

    return tokens;
  }

  let currentLength = 0;

  for (let i = tokens.length - 1; i >= 0; i--) {
    const token = tokens[i];
    const tokenLength = typeof token === 'string' ? token.length : token[0].length;

    if (currentLength + tokenLength > -limit) {
      const remainingChars = -limit - currentLength;

      if (typeof token === 'string' && remainingChars > 0) {
        return [token.slice(token.length - remainingChars), ...tokens.slice(i + 1)];
      }

      if (typeof token !== 'string' && remainingChars > 0) {
        return [
          [token[0].slice(token[0].length - remainingChars), token[1]],
          ...tokens.slice(i + 1),
        ];
      }

      return tokens.slice(i + 1);
    }

    currentLength += tokenLength;
  }

  return tokens;
};
